import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Divider } from "ctia-ui";
import Field from "containers/request/Payments/LabeledField";
import { formatCurrency } from "helpers/StringHelper";
import { formatDate } from "helpers/DateHelper";

const RequestDetailsOta = ({ app, request }) => {
  if (!app || !app.isOTACert || _.isEmpty(_.pickBy(request, _.identity)))
    return null;

  const {
    id,
    tn,
    vendor,
    invoice,
    typeTitle,
    billingPocName,
    billingPocPhone,
    billingPocEmail,
    billingAddress,
    billingCompanyName,
    model
  } = request;

  const reqDetails = [
    {
      id: "requestId",
      label: "Request ID",
      content: <Link to={`/ota/accountant/requests/${id}`}>{tn}</Link>
    },
    {
      id: "vendor",
      label: "Vendor",
      content: vendor
    },
    {
      id: "modelName",
      label: "Model Name/Number",
      content: model.modelnumber
    },
    {
      id: "requestType",
      label: "Request Type",
      content: typeTitle
    },
    {
      id: "billingCompany",
      label: "Billing Company",
      labelStyle: "primary",
      content: billingCompanyName
    },
    {
      id: "billingAddress",
      label: "Billing Address",
      labelStyle: "primary",
      content: billingAddress
    },
    {
      id: "billingPOC",
      label: "Billing PoC",
      labelStyle: "primary",
      content: billingPocName
    },
    {
      id: "billingPhone",
      label: "Billing Phone",
      labelStyle: "primary",
      content: billingPocPhone
    },
    {
      id: "billingEmail",
      label: "Billing Email",
      labelStyle: "primary",
      content: billingPocEmail
    }
  ];

  const invoiceDetails = [
    {
      id: "invoiceId",
      label: "Invoice Number",
      content: tn
    },
    {
      id: "invoiceDate",
      label: "Invoice Date",
      content: formatDate(invoice.createdat)
    },
    {
      id: "invoiceAmount",
      label: "Invoice Amount",
      labelStyle: "success",
      content: <b>{formatCurrency(invoice.totalamount)}</b>
    }
  ];

  const renderForm = formFields =>
    formFields.map(field => {
      return <Field {...field} key={field.id} />;
    });

  const costs = invoice.invoicecosts.map(cost => {
    return {
      id: `OTA-${cost.id}`,
      label: cost.item,
      content: formatCurrency(cost.amount)
    };
  });

  return (
    <div>
      <h1 className="block-bottom-offset">Request Details</h1>
      <Form horizontal>{renderForm(reqDetails)}</Form>
      <Divider />
      <h1 className="block-bottom-offset">Invoice Details</h1>
      <Form horizontal>{renderForm(invoiceDetails)}</Form>
      <Divider />
      <Form horizontal>{renderForm(costs)}</Form>
    </div>
  );
};

function mapStateToProps({ app, request }) {
  return { app, request };
}

export default connect(mapStateToProps)(RequestDetailsOta);
